import { UiComponent, UiComponentProps } from './ui-component';

export type ButtonProps = UiComponentProps & {
	onClick: (event: MouseEvent) => void;
};

export class Button extends UiComponent<ButtonProps> {
	render(): HTMLButtonElement {
		const buttonElement = document.createElement('button');

		this.getClassNames().forEach((className) => buttonElement.classList.add(className));
		buttonElement.addEventListener('click', (event) => this.onClick(event));

		return buttonElement;
	}

	getClassNames(): string[] {
		return ['button-control', ...super.getClassNames()];
	}

	onClick(event): void {
		const { onClick } = this.props;

		if (typeof onClick === 'function') {
			onClick(event);
		}
	}
}
